/** The YogiQL version these encoders write; bumped with the backend's
 *  `YOGIQL_VERSION` in the PR that changes the request shape. */
export const YOGIQL_VERSION = '1.1'

/** `body` stamped with the version its encoder was written for. Every
 *  request builder goes through this, so a stored request carries it too. */
export const withYogiQLVersion = <T extends object>(
  body: T,
): { yogiql: string } & T => ({ yogiql: YOGIQL_VERSION, ...body })

/** `catalog`, after a devtools warning when this bundle writes another
 *  version than the API reads: a stale tab, fixed by a reload. */
export const checkYogiQLVersion = <T extends { yogiql: string }>(
  catalog: T,
): T => {
  if (catalog.yogiql !== YOGIQL_VERSION) {
    // eslint-disable-next-line no-console -- the stale-bundle signal PROD-6164 asks for; permanent: there is no client logger to route it through
    console.warn(
      `[yogiql] this page writes YogiQL ${YOGIQL_VERSION} but the API reads ${catalog.yogiql}; reload to update`,
    )
  }
  return catalog
}
